import Banner from '../banner';
import { Image } from '../image';

export class AdvertisementAdapter {
    static adapt({ image, link }: { image: Image; link: string }): Banner {
        return new Banner(image && image.imagePath, '', link);
    }
}
